"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageAttributesContext = exports.componentAttributesContext = exports.brandAttributesContext = void 0;
const brandAttributes_1 = __importDefault(require("./brandAttributes"));
exports.brandAttributesContext = brandAttributes_1.default;
const componentAttributes_1 = __importDefault(require("./componentAttributes"));
exports.componentAttributesContext = componentAttributes_1.default;
const pageAttributes_1 = __importDefault(require("./pageAttributes"));
exports.pageAttributesContext = pageAttributes_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZGF0YVN0cnVjdHVyZXMvZW50aXRpZXMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0VBQXVEO0FBSTlDLGlDQUpGLHlCQUFzQixDQUlFO0FBSC9CLGdGQUErRDtBQUc5QixxQ0FIMUIsNkJBQTBCLENBRzBCO0FBRjNELHNFQUFxRDtBQUVRLGdDQUZ0RCx3QkFBcUIsQ0FFc0QifQ==


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/index.ts